import React, { useMemo } from "react";
import QuestionCarousel, { QuestionItem } from "../QuestionCarousel/QuestionCarousel";

interface WelcomeScreenProps {
  onTipClick: (question: string) => void;
}

function getRandomTips(tips: QuestionItem[], count: number = 5): QuestionItem[] {
  const shuffled = [...tips].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}

const allTips: QuestionItem[] = [
  // --- Erziehung & Schule ---
  {
    category: "Erziehung & Schule",
    question: "Ich bin Lehrer und ein Kind in meiner Klasse ist extrem aufbrausend und cholerisch. Wie kann ich sein Temperament besser verstehen, statt es nur als Störung zu sehen?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Kind ist 9 und will plötzlich nicht mehr in die Schule. Hat das mit dem Rubikon zu tun, von dem in der Waldorfpädagogik gesprochen wird?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Kind ist 10 und alle in der Klasse haben ein Smartphone. Steiner spricht davon, dass Kinder in bestimmten Phasen geschützt werden müssen – gilt das auch für digitale Medien?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Teenager rebelliert gegen alles und stellt alles in Frage. Steiner beschreibt, dass mit 14 etwas Neues im Menschen erwacht – ist das der Astralleib?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Kind ist 5 und ich möchte es fördern, aber ich hab gelesen, dass man laut Steiner im ersten Jahrsiebt gar nicht intellektuell fördern soll. Stimmt das?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Kind kann sich kaum konzentrieren und ist ständig unruhig. Kann das mit seinem Temperament zusammenhängen, und wie gehe ich als Elternteil damit um?",
  },
  {
    category: "Erziehung & Schule",
    question: "Mein Kind hat sein Haustier verloren und fragt mich, wo es jetzt ist. Steiner spricht von einer geistigen Welt – wie erkläre ich das einem Kind, ohne es zu überfordern?",
  },
  {
    category: "Erziehung & Schule",
    question: "Ich überlege, mein Kind auf eine Waldorfschule zu schicken. Was ist an Steiners Erziehungsidee wirklich anders – geht es nur um Handarbeit und Eurythmie, oder steckt mehr dahinter?",
  },

  // --- Beziehung & Liebe ---
  {
    category: "Beziehung & Liebe",
    question: "Meine Freundin hat mich verlassen und ich frage mich, ob diese Begegnung einen tieferen Sinn hatte. Steiner spricht von Karma zwischen Menschen – war das vorbestimmt?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Warum treffe ich immer wieder auf den gleichen Typ Partner, der mir nicht gut tut? Hat das etwas mit Karma aus früheren Leben zu tun?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Ich habe jemanden kennengelernt und hatte sofort das Gefühl, diese Person schon ewig zu kennen. Steiner spricht von karmischen Begegnungen – kann das so eine sein?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Mein Partner und ich haben uns auseinandergelebt. Kann es sein, dass wir uns karmisch das gegeben haben, was wir brauchten, und jetzt weitergehen müssen?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Wie kann ich meine Eifersucht verstehen und verwandeln, statt mich von ihr beherrschen zu lassen? Hat das mit dem Egoismus zu tun, den Steiner in der Liebe beschreibt?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Mein Partner lebt weit weg und manchmal fühle ich mich trotzdem ganz nah. Steiner spricht davon, dass Seelen über die physische Welt hinaus verbunden sind – wie ist das gemeint?",
  },
  {
    category: "Beziehung & Liebe",
    question: "Mein Partner und ich sind in vielem total verschieden. Kann es sein, dass sich Gegensätze karmisch anziehen, weil man voneinander lernen soll?",
  },

  // --- Beruf & Arbeit ---
  {
    category: "Beruf & Arbeit",
    question: "Ich hasse meinen Job, aber ich brauche das Geld. Steiner spricht davon, dass Arbeit mehr sein soll als Broterwerb – aber wie finde ich diesen tieferen Sinn in meiner Situation?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Ich bin Ende 20 und weiß nicht, was ich beruflich machen soll. Steiner beschreibt, dass jeder Mensch eine Aufgabe mitbringt – wie finde ich meine?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Mein Chef behandelt mich unfair und ich merke, wie es mich innerlich auffrisst. Steiner spricht von der Nebenübung der Gelassenheit – wie kann ich das praktisch umsetzen?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Ich fühle mich im Beruf völlig ausgebrannt. Steiner spricht von einem Rhythmus zwischen Denken, Fühlen und Wollen – habe ich dieses Gleichgewicht verloren?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Ist es egoistisch, einen sicheren Job aufzugeben, um meinem Herzen zu folgen? Oder gehört dieser Mut zur inneren Freiheit, von der Steiner spricht?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Ich habe ständig Konflikte mit einem Kollegen und frage mich, warum gerade dieser Mensch mich so triggert. Kann das eine karmische Lernaufgabe sein?",
  },
  {
    category: "Beruf & Arbeit",
    question: "Ich bin selbstständig und habe Existenzängste. Steiner spricht davon, dass der Mensch Vertrauen in die geistige Welt entwickeln kann – wie lerne ich das?",
  },

  // --- Gesundheit & Wohlbefinden ---
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich schlafe seit Wochen schlecht und grüble nachts. Steiner beschreibt, dass die Seele im Schlaf den Körper verlässt – kann es sein, dass meine Seele nicht richtig zur Ruhe kommt?",
  },
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich bin oft krank, seit ich eine schwere Zeit durchmache. Steiner spricht davon, dass Leib, Seele und Geist zusammenwirken – kann seelisches Leid wirklich den Körper krank machen?",
  },
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich habe chronische Schmerzen und die Schulmedizin findet nichts. Kann die anthroposophische Medizin einen anderen Blick darauf werfen?",
  },
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich überlege, vegetarisch zu leben. Steiner hat sich dazu geäußert – stimmt es, dass Fleisch die geistige Entwicklung beeinflusst?",
  },
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich leide unter Panikattacken und habe das Gefühl, mich in meinem eigenen Körper nicht sicher zu fühlen. Steiner spricht von einem Ätherleib, der uns Lebenskraft gibt – kann man den stärken?",
  },
  {
    category: "Gesundheit & Wohlbefinden",
    question: "Ich bin ständig müde und antriebslos, obwohl ich genug schlafe. Steiner beschreibt verschiedene Lebenskräfte – kann es sein, dass mir eine davon fehlt?",
  },

  // --- Sinnfragen & Lebenskrisen ---
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Ich bin in einer tiefen Krise und sehe keinen Sinn mehr. Steiner spricht davon, dass gerade solche Krisen ein Tor zur geistigen Entwicklung sein können – wie ist das gemeint?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Warum passieren guten Menschen schlechte Dinge? Steiner spricht von Karma und Schicksal – heißt das, dass Leid immer einen Sinn hat?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Ich bin Anfang 40 und mein ganzes bisheriges Leben fühlt sich plötzlich falsch an. Steiner beschreibt um das 42. Lebensjahr eine große Wende – was passiert da eigentlich?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Mein Vater ist gestorben und ich frage mich ständig, wo er jetzt ist. Steiner beschreibt einen Weg der Seele nach dem Tod – was erlebt die Seele in Kamaloka und Devachan?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Ich habe meine Mutter verloren und fühle sie manchmal noch ganz nah. Steiner sagt, die Verstorbenen sind nicht weg – kann man wirklich eine Verbindung zu ihnen pflegen?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Gibt es Schicksal, oder gestalte ich mein Leben selbst? Steiner spricht von Freiheit und Karma gleichzeitig – ist das nicht ein Widerspruch?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Warum wiederholen sich bestimmte Muster in meinem Leben, egal was ich tue? Steiner spricht davon, dass wir karmische Aufgaben mitbringen – hängt das damit zusammen?",
  },
  {
    category: "Sinnfragen & Lebenskrisen",
    question: "Ich fühle mich einsam, obwohl ich ständig unter Menschen bin. Steiner beschreibt, dass das Ich sich von der geistigen Welt abgetrennt fühlen kann – ist das mein Problem?",
  },

  // --- Spiritualität & Selbstentwicklung ---
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich möchte mich geistig weiterentwickeln, weiß aber nicht wo anfangen. Steiner beschreibt einen Schulungsweg mit Imagination, Inspiration und Intuition – was bedeutet das praktisch?",
  },
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich möchte meditieren lernen, aber die östlichen Wege sprechen mich nicht an. Steiner hat eine eigene Meditationspraxis entwickelt – wie unterscheidet sich die Rückschau von anderen Methoden?",
  },
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich bin aus der Kirche ausgetreten, suche aber trotzdem nach etwas Geistigem. Steiner spricht von einer Geisteswissenschaft, die ohne Glauben auskommt – wie geht das?",
  },
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich komme im Alltag kaum zur Ruhe. Steiner empfiehlt sechs Nebenübungen für die innere Entwicklung – kann mir das helfen, achtsamer zu werden?",
  },
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich bin Naturwissenschaftler und tue mich schwer mit Spiritualität. Aber Steiner war ja selbst Naturwissenschaftler – wie verbindet er Wissenschaft und Geist?",
  },
  {
    category: "Spiritualität & Selbstentwicklung",
    question: "Ich hatte früher einen starken Glauben, aber jetzt zweifle ich an allem. Steiner beschreibt den Zweifel als notwendige Stufe der Erkenntnis – ist das wirklich so?",
  },

  // --- Gesellschaft & Zusammenleben ---
  {
    category: "Gesellschaft & Zusammenleben",
    question: "Die Welt scheint immer schlimmer zu werden und ich verliere die Hoffnung. Steiner spricht von Ahriman und Luzifer als geistigen Kräften – hilft mir das, die Welt besser zu verstehen?",
  },
  {
    category: "Gesellschaft & Zusammenleben",
    question: "Ich gerate ständig in Streit mit Menschen, die politisch völlig anders denken. Steiner spricht von einer sozialen Dreigliederung – kann das helfen, solche Konflikte anders zu sehen?",
  },
  {
    category: "Gesellschaft & Zusammenleben",
    question: "Ich habe das Gefühl, dass mich jemand in meinem Umfeld manipuliert, aber ich kann es nicht greifen. Steiner spricht von ahrimanischen Kräften, die in zwischenmenschlichen Beziehungen wirken – was meint er damit?",
  },
  {
    category: "Gesellschaft & Zusammenleben",
    question: "Ich engagiere mich sozial, aber es fühlt sich nie genug an und ich brenne aus. Steiner spricht von einem Gleichgewicht zwischen Selbstentwicklung und Weltdienst – wie finde ich das?",
  },
  {
    category: "Gesellschaft & Zusammenleben",
    question: "Warum funktioniert unsere Gesellschaft so ungerecht, obwohl alle Gerechtigkeit wollen? Steiner hat mit der Dreigliederung eine Alternative entworfen – ist die heute noch aktuell?",
  },

  // --- Natur & Umwelt ---
  {
    category: "Natur & Umwelt",
    question: "Ich mache mir große Sorgen um die Umwelt. Steiner spricht davon, dass die Erde selbst ein lebendiges Wesen ist – wie verändert das unsere Verantwortung?",
  },
  {
    category: "Natur & Umwelt",
    question: "Ich habe angefangen, mich für biologisch-dynamische Landwirtschaft zu interessieren. Was hat Steiner mit den kosmischen Kräften gemeint, die auf Pflanzen wirken?",
  },
  {
    category: "Natur & Umwelt",
    question: "Warum fühle ich mich im Wald so viel lebendiger und ruhiger als in der Stadt? Steiner spricht von Elementarwesen in der Natur – gibt es da wirklich etwas, das man spüren kann?",
  },
];

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onTipClick }) => {
  // Only shuffle once on mount, not on every render
  const tips = useMemo(() => getRandomTips(allTips, allTips.length), []);

  return (
    <div className="welcome-screen">
      <h1 className="welcome-title">Willkommen</h1>
      <p className="welcome-subtitle">
        Hier können Sie Ihre Fragen zum Werk Rudolf Steiners stellen
      </p>
      <QuestionCarousel questions={tips} onQuestionClick={onTipClick} />
    </div>
  );
};

export default WelcomeScreen;
